/**
 * Feature flags for the application.
 * Toggle features on/off without code changes.
 */
export const FEATURE_FLAGS = {
  /**
   * Enables the "Prueba la clase gratis" flow on the home page:
   * - Lead-magnet section (#leads) with SubscriptionForm
   * - "Ver Clase Gratis" buttons in header, hero, CTA, and mobile bar
   */
  FREE_CLASS_ENABLED: true,
} as const;

